module.exports = __webpack_public_path__ + "img/home-world-best-banner-03.724f2ddf.jpg";